export default __webpack_public_path__ + "static/media/pdf.bd1dd828.png";